import React from 'react';
import commonTools from '../../../common/util/util'
import util from "../../util/tools";
import Header from "../common/Header";

export default class TouchBottom extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            pageParams: {}
        }
    }
    componentDidMount = () => {
        const queryParams = commonTools.searchPar()
        console.log(queryParams)
        if (JSON.stringify(queryParams) !== '{}') {
            this.setState({
                pageParams: queryParams
            }, () => {
                // this.submitToutiao()
            })
        }
    }
    submitToutiao() {
        util.ajax({
            url: "/quickapp/toutiao/add",
            method: 'post',
            isUser: true,
            data: {
                adid: this.state.pageParams.adid,
                creativeid: this.state.pageParams.creativeid,
                creativetype: this.state.pageParams.creativetype,
                clickid: this.state.pageParams.clickid,
                qa_source: this.state.pageParams.source,
            },
            callback: (res) => {
                console.log(res)
            }
        })
    }
    render() {
        return (
            <div ref="touchBottom" style={{height:"100%"}}>
                {/* <Header title='分享'/> */}
                <div style={{ textAlign: 'center', marginTop: 100 }}>
                    <img style={{ width: '60%' }} src={ this.state.pageParams.qrcodeurl } alt=""></img>
                </div>
            </div>
        );
    }
}